/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilityAlternativeName
 */
export interface FacilityAlternativeName {
    /**
     * 
     * @type {string}
     * @memberof FacilityAlternativeName
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityAlternativeName
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityAlternativeName
     */
    facility_id?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityAlternativeName
     */
    organization_id?: string;
}

/**
 * Check if a given object implements the FacilityAlternativeName interface.
 */
export function instanceOfFacilityAlternativeName(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function FacilityAlternativeNameFromJSON(json: any): FacilityAlternativeName {
    return FacilityAlternativeNameFromJSONTyped(json, false);
}

export function FacilityAlternativeNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityAlternativeName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'organization_id': !exists(json, 'organization_id') ? undefined : json['organization_id'],
    };
}

export function FacilityAlternativeNameToJSON(value?: FacilityAlternativeName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'facility_id': value.facility_id,
        'organization_id': value.organization_id,
    };
}

